import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class StatistiqueService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getStatisticsByYearAndWeekNumber(
		year: number,
		weekNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.statisticsUrl}/${year}/${weekNumber}`,
			'getStatisticsByYearAndWeekNumber'
		);
	}

	getActivityReportByEmployeeByYearAndWeekNumber(
		year: number,
		weekNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activityReportEmployeeUrl}/${year}/${weekNumber}`,
			'getActivityReportByEmployeeByYearAndWeekNumber'
		);
	}

	getActivityReportByBeneficiaireByYearAndWeekNumber(
		year: number,
		weekNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activityReportBeneficiaireUrl}/${year}/${weekNumber}`,
			'getActivityReportByBeneficiaireByYearAndWeekNumber'
		);
	}

	getActivityReportByBeneficiaireByYearAndMonth(
		year: number,
		monthNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activityReportBeneficiaireUrl}/month/${monthNumber}/${year}`,
			'getActivityReportByBeneficiaireByYearAndMonth'
		);
	}

	getActivityReportByEmployeeByYearAndMonth(
		year: number,
		monthNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activityReportEmployeeUrl}/month/${monthNumber}/${year}`,
			'getActivityReportByEmployeeByYearAndMonth'
		);
	}

	getFunderReport(year: number, weekNumber: number): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.funderReportUrl}/${year}/${weekNumber}`,
			'getFunderReport'
		);
	}

	getDailyStatisticsReportByYearAndWeekNumber(
		year: number,
		weekNumber: number
	): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.statisticsUrl}/${year}/${weekNumber}/daily`,
			'getActivityReportByBeneficiaireByYearAndWeekNumber'
		);
	}

	getActivityReportSAEByDate(start: number, end: number): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activityReportSAEByDateUrl}/${start}/${end}`,
			'getActivityReportSAEByDate'
		);
	}
}
